import logo from "Shared/styles/logo.png";

export const Logo = ({ ...props }) => <img src={logo} height={40} {...props} />;
